<div  v-if="shouldRenderConfig" v-bind:class="[getClassName, getDisabledClass]">    
    <button type="button" class="btn btn-primary" v-bind:class="activeClass()" v-on:click="onClickSelectPageOption(code)">
        <div v-bind:class="getClassName + 'Index'">{{index + 1}}</div>
        <div v-bind:class="getClassName + 'Label'">{{name}}</div>
        <appTooltip v-if="tooltip" :tooltip="tooltip"></appTooltip>
        <appAwesomeIcon v-if="getIsShowCheckedPageOptionFlag && checked" icon="check" useClass="pageOptionCheck" />
    </button>
    
    <div v-if="getPageAttributesInPageOptions">
        <appPageOptionAttributesContainer v-bind:code="code"></appPageOptionAttributesContainer>
    </div>
</div>